<template>
  <TournamentForm :isEdit="true" :id="$route.params.id" />
</template>

<script>
import TournamentForm from "@/components/tournament/TournamentForm.vue";

export default {
  name: "TournamentEditPage",
  components: {
    TournamentForm,
  },
};
</script>
